import { z } from 'zod'

export const medicalActsNegotiationSchema = z
	.object({
		establishmentId: z.string(),
		providers: z.array(z.string()),
		medicalActs: z.array(z.string()),
		medicalActPrices: z
			.array(
				z.object({
					medicalActId: z.string(),
					price: z.number().optional(),
				})
			)
			.optional(),
	})
	.strict()
